import { render, staticRenderFns } from "./URegisterPassEditComp.vue?vue&type=template&id=6218cb09&scoped=true&"
import script from "./URegisterPassEditComp.vue?vue&type=script&lang=ts&"
export * from "./URegisterPassEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./URegisterPassEditComp.vue?vue&type=style&index=0&id=6218cb09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6218cb09",
  null
  
)

export default component.exports